import Block from '../block'

export default class Nav extends Block {
	static title = 'nav'

	constructor($el) {
		super($el)
		// show collapsed menu when too many items in the nav
		this.resizeMenu()

		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				this.$el.addClass('nav--ready')
			})
		})
		window.addEventListener('resize', () => this.resizeMenu())
		// logo image and web fonts change the widths after a cold load
		window.addEventListener('load', () => this.resizeMenu())
		document.fonts?.ready.then(() => this.resizeMenu())

		// open side menu
		this.$el.findElement('toggle').on('click', () => {
			if (this.isOpen()) {
				this.close()
			} else {
				this.open()
			}
		})

		this.$el.findElement('popup-close').on('click', () => this.close())

		$(document).on('keydown', (e) => {
			if (e.key !== 'Escape' || !this.isOpen()) {
				return
			}

			this.close()
			this.$el.findElement('toggle').get(0)?.focus()
		})

		this.$el.findElement('popup-overlay').on('click', () => this.close())

		this.$el.findElement('subs-toggle').on('click', (el) => {
			$(el.currentTarget)
				.siblings('.nav__subs')
				.removeClass('hidden')
				.find('.nav__back')
				.get(0)
				?.focus()
		})

		this.$el.findElement('back').on('click', (el) => {
			this.$el.findElement('subs').addClass('hidden')
			$(el.currentTarget)
				.closest('.nav__item')
				.find('.nav__subs-toggle')
				.get(0)
				?.focus()
		})

		$(document).on('product:add', (index, data) => {
			this.$el.findElement('count--span').text(data.count)
		})

		$(document).on('product:remove', (index, data) => {
			this.$el.findElement('count--span').text(data.count)
		})

		$(document).on('product:update', (index, data) => {
			this.$el.findElement('count--span').text(data.count)
		})
	}

	isOpen() {
		return (
			this.$el.hasClass('nav--active') && !this.$el.hasClass('nav--closing')
		)
	}

	open() {
		this.closing = null
		this.$el.removeClass('nav--closing').addClass('nav--active')
		this.$el.findElement('open').addClass('mobile:hidden')
		this.$el.findElement('close').removeClass('mobile:hidden')
		this.$el.findElement('items').removeClass('mobile:hidden')
		this.$el.findElement('popup').removeClass('desktop:hidden')
		this.$el.findElement('subs').addClass('hidden')
		this.syncExpanded()
	}

	// the closing modifier runs the theme's exit animations; items and popup only hide once they finish
	async close() {
		const token = (this.closing = {})
		const $targets = this.$el
			.findElement('items')
			.add(this.$el.findElement('popup'))

		this.$el.addClass('nav--closing')
		this.$el.findElement('close').addClass('mobile:hidden')
		this.$el.findElement('open').removeClass('mobile:hidden')
		this.syncExpanded()

		const running = $targets
			.get()
			.flatMap((el) => el.getAnimations({ subtree: true }))
			.filter((a) => a.effect?.getComputedTiming().endTime !== Infinity)

		await Promise.allSettled(running.map((a) => a.finished))

		// reopened mid-exit
		if (this.closing !== token) return

		this.closing = null
		this.$el.findElement('items').addClass('mobile:hidden')
		this.$el.findElement('popup').addClass('desktop:hidden')
		this.$el.removeClass('nav--active nav--closing')
	}

	syncExpanded() {
		this.$el
			.findElement('toggle')
			.attr('aria-expanded', this.isOpen() ? 'true' : 'false')
	}

	resizeMenu() {
		if (this.$el.hasModifier('dekstop-popup')) {
			return false
		}

		const mainWidth = this.$el.findElement('main').outerWidth()

		if (this.itemsWidth() >= mainWidth - 20) {
			this.$el.addClass('nav--popup')
			this.$el.findElement('items').addClass('desktop:hidden')
			this.$el.findElement('toggle').removeClass('desktop:hidden')
		} else {
			this.$el.removeClass('nav--popup')
			this.$el.findElement('popup').addClass('desktop:hidden')
			this.$el.findElement('items').removeClass('desktop:hidden')
			this.$el.findElement('toggle').addClass('desktop:hidden')
		}
	}

	// natural width of the items: visible, unwrapped and unshrunk
	itemsWidth() {
		const $items = this.$el.findElement('items')
		const items = $items.get(0)
		const hidden = $items.hasClass('desktop:hidden')

		$items.removeClass('desktop:hidden')
		items.style.whiteSpace = 'nowrap'
		items.style.flexShrink = '0'
		const width = items.scrollWidth
		items.style.whiteSpace = ''
		items.style.flexShrink = ''
		if (hidden) {
			$items.addClass('desktop:hidden')
		}

		return width
	}
}
